import React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
// --- external imports ------

import newspaperBg from '~/assets/images/baseAssets/newspaper/bg-newspaper.png';
import closeBtnProjection from '~/assets/images/baseAssets/btn-cancel-53.png';
import { gameSelectors } from '~/store';
// --- internal imports ------

import Asset from '../BaseAssets';
// --- parent imports ------

import NewspaperHeader from './NewspaperHeader';
import NewspaperPreviewWrapper from './NewspaperPreviewWrapper';
import NewspaperList from './NewspaperList';
import NewspaperSort from './NewspaperSort';
// --- local imports ------

function NewspaperModal(props) {
	const { cash } = props;
	const [selectedItem, setSelectedItem] = React.useState(null);

	React.useEffect(
		() => {
			if (props.list.length === 0) {
				setSelectedItem(null);
			}
			else {
				setSelectedItem(props.list[0]);
			}
		}, [props.list]
	);

	function handleBrowseClick(entry) {
		setSelectedItem(entry);
	}

	function handleOnRentClick() {
		const hasEnoughCash = cash > selectedItem.price;
		props.onRentClick(selectedItem, hasEnoughCash);
	}

	const isRentBtnDisabled = selectedItem && typeof props.disableRentBtn === 'function'
		? props.disableRentBtn(selectedItem)
		: props.disableRentBtn;

	return (
		<ModalBackground>
			<Asset.Img
				x={33}
				y={40}
				projection={newspaperBg}
				data-testid={props['data-testid']}
			/>
			
			<NewspaperCloseBtn
				x={1200}
				y={70}
				onClick={props.onClose}
				data-testid={`${props['data-testid']}-close-btn`}
			/>

			<NewspaperHeader
				displayDetails={props.displayDetails}
				data-testid-prefix={`${props['data-testid']}-header`}
			/>

			<NewspaperSort />

			{selectedItem && (
				<NewspaperPreviewWrapper
					entry={selectedItem}
					displayDetails={props.displayDetails}
					testBaseName={`${props['data-testid']}-preview`}
				/>
			)}

			<NewspaperList
				onClick={handleBrowseClick}
				selectedItem={selectedItem}
				list={props.list}
				renderer={props.displayDetails?.listItemRenderer}
				data-testid-prefix={props['data-testid']}
			/>

			{selectedItem && (
				<props.displayDetails.rentButton
					x={1123}
					y={627}
					fontSize={14}
					onClick={handleOnRentClick}
					disabled={isRentBtnDisabled}
					data-testid={`${props['data-testid']}-rent-btn`}
				/>
			)}

		</ModalBackground>
	);
}

const NewspaperCloseBtn = styled(Asset.Button.withProps({
	projection: closeBtnProjection
}))`
	padding: 0;
	border-radius: 50%;
	background-color: transparent;
	background-repeat: no-repeat;
	&:hover {
		box-shadow: 0em 0em 16em white;
	}
`;

const ModalBackground = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.52);
	z-index: 80;
`;

function mapStoreStateToProps(storeState) {
	return {
		cash: gameSelectors.getCash(storeState),
	};
}

export default connect(mapStoreStateToProps, null)(NewspaperModal);

